import { createElement } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Spinner } from '../Spinner/index.js';
import styles from 'ui-components/Button.scss';

var _excluded = ["loading", "disabled", "size", "variant", "slotLeft", "slotRight", "elem", "className"];
var Button = function Button(_ref) {
  var _cn, _cn2, _cn3, _cn4;
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    variant = _ref.variant,
    slotLeft = _ref.slotLeft,
    slotRight = _ref.slotRight,
    elem = _ref.elem,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Elem = typeof elem === "undefined" ? "button" : elem;
  var spinnerVariant = ["ghost", "blank"].includes(variant) ? "primary" : "";
  var spinnerSize = variant === "blank" ? "small" : "";
  return /*#__PURE__*/createElement(Elem, _extends({}, props, {
    disabled: disabled || loading,
    className: cn(styles.button, (_cn = {}, _cn[styles.hasVariant] = Boolean(variant), _cn), (_cn2 = {}, _cn2[styles[variant]] = Boolean(variant), _cn2), (_cn3 = {}, _cn3[styles["size__" + size]] = Boolean(size), _cn3), (_cn4 = {}, _cn4[styles.loading] = loading, _cn4), className)
  }), Boolean(slotLeft) && /*#__PURE__*/createElement("div", {
    className: styles.slotLeft
  }, /*#__PURE__*/createElement("div", {
    className: styles.slot
  }, slotLeft)), props.children, loading && /*#__PURE__*/createElement(Spinner, {
    variant: spinnerVariant,
    className: spinnerSize
  }), Boolean(slotRight) && /*#__PURE__*/createElement("div", {
    className: styles.slotRight
  }, /*#__PURE__*/createElement("div", {
    className: styles.slot
  }, slotRight)));
};

export { Button };
//# sourceMappingURL=index.js.map
